var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingR2 = function SvgEarRingR2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 26,
    height: 32,
    viewBox: "0 0 0.52 0.65",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.1;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2314197545792"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.08.13C.14.02.43-.01.44.26.45.33.45.39.43.43M.29.55S.28.55.26.56C.21.57.06.57.05.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.3.24C.23.21.09.29.19.32.26.34.26.39.16.39.15.39.13.4.12.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.46.42C.51.45.53.5.52.55.52.58.5.61.47.63.45.65.41.66.38.65.34.64.29.62.27.55.25.47.29.44.34.42h.01C.36.41.38.4.39.4.41.4.44.4.46.42zM.41.48C.49.54.38.62.35.53.34.5.37.5.38.49.39.48.41.48.41.48z",
    fill: "#000"
  })))));
};

export default SvgEarRingR2;